import React from "react";
import {useTranslation} from "react-i18next";

import Title from "components/atoms/TitleTemplate";
import Image from "components/atoms/Image";

import "./style.scss"

const TokenNine = () => {
    const {t} = useTranslation()

    return (
        <section className="token-nine">
            <div className="container">
                <Title underline={true}>{t("tokenTabFinancialTitlePartOne")} <span>{t("tokenTabFinancialTitlePartTwo")}</span></Title>
                <div className="book-financial">
                    <div className="book-financial_left">
                        <h3>{t("tokenTabFinancialArticleTitlePartOne")} <span> <br/>{t("tokenTabFinancialArticleTitlePartTwo")}</span></h3>
                        <p>{t("tokenTabFinancialArticleContent")} </p>
                    </div>
                    <div className="book-financial_right">
                        <Image className="c1" alt="coin" src="/images/c1.png"/>
                    </div>
                    <Image className="c2" alt="coin" src="/images/c2.png"/>
                    <Image className="c5" alt="coin" src="/images/c5.png"/>
                    <Image className="c4" alt="coin" src="/images/c4.png"/>
                </div>
            </div>
        </section>
    )
}
export default TokenNine